module.exports = __webpack_public_path__ + "img/teaser_traktor5.fa0b65a9.jpg";